export default __webpack_public_path__ + "static/media/email.46754352.png";